import { c as _c } from "react/compiler-runtime";
import { SphereIconButton } from "@components/common/sphere-icon-button";
import { MANAGE_SEATS_TITLE, ManageSeatsDialog } from "@components/table/members/assign-seats/manage-seats-dialog";
import { PlusIcon, Tooltip } from "@flat-ui";
import { SHOW_ON_HOVER_CLASS } from "@utils/ui-utils";
import { useState } from "react";

/**
 * Button that lets the user pick seats of the workspace subscription to give a member, in a dialog.
 *
 * It is only shown while the row is hovered, since a members table that offered the action on every
 * row would draw the attention away from the seats the members do hold.
 */
export function ManageSeatsButton(t0) {
  const $ = _c(6);
  const {
    member
  } = t0;
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      visibility: "hidden"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Tooltip component="div" title={MANAGE_SEATS_TITLE} sx={t1} data-testid="MANAGE_SEATS_BUTTON" className={SHOW_ON_HOVER_CLASS}><SphereIconButton buttonSize="24px" iconSize="22px" component={PlusIcon} onClick={() => setIsDialogOpen(true)} /></Tooltip>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setIsDialogOpen(false);
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== isDialogOpen || $[4] !== member) {
    t4 = <>{t2}<ManageSeatsDialog member={member} isOpen={isDialogOpen} onClose={t3} /></>;
    $[3] = isDialogOpen;
    $[4] = member;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}